<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading"
                            v-if="page.isNew && $check(user, ['lawyers.create'])">Criar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading"
                            v-if="!page.isNew && $check(user, ['lawyers.update'])">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/procuradores">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row v-if="dataset.data.account_verified_at === '0000-00-00 00:00:00'">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">
                        mdi-alert-outline
                    </v-icon>
                    Este procurador ainda não verificou o cadastro

                    <template v-slot:actions>
                        <v-btn :disabled="!$check(user, ['lawyers.update.verify'])" color="primary" text
                            @click="verifyAccount()">
                            VERIFICAR AGORA
                        </v-btn>
                    </template>
                </v-banner>
            </v-col>
        </v-row>
        <!--
        <v-row v-if="dataset.data.account_approved_at !== '0000-00-00 00:00:00' && dataset.data.type === 1">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="accent" size="36">
                        mdi-check-circle-outline
                    </v-icon>
                    Este credor está incluso na lista de credores
                </v-banner>
            </v-col>
        </v-row> -->
        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes
                                    <v-chip v-if="dataset.data.is_executor" color="warning" text-color="black" small class="ml-3">
                                        <v-icon left small>mdi-gavel</v-icon>
                                        Inventariante
                                    </v-chip>

                                    <v-tooltip v-if="dataset.data.is_executor" bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon  small class="ml-2" color="grey"
                                                v-bind="attrs" v-on="on">
                                                mdi-information-outline
                                            </v-icon>
                                        </template>
                                        <span>
                                            Este procurador atua como inventariante no processo.
                                        </span>
                                    </v-tooltip>

                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-text-field dense id="procurator_name" label="Nome procurador"
                                                v-model="dataset.data.procurator_name" required
                                                :rules="[$rules.required]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['lawyers.update']))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <v-text-field dense id="procurator_federal_registration" label="Número OAB"
                                                v-model="dataset.data.procurator_federal_registration" required
                                                :rules="[$rules.required]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['lawyers.update']))">
                                            </v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-autocomplete dense required :items="dataset.statesList" label="OAB UF"
                                                v-model="dataset.data.procurator_federal_registration_uf"
                                                item-value="name" item-text="name" :rules="[$rules.required]" outlined
                                                hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['lawyers.update']))">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field dense id="procurator_registration" label="CPF"
                                                v-model="dataset.data.procurator_registration" required
                                                :rules="[$rules.required, $rules.cpf]" outlined hide-details="auto"
                                                v-mask="['###.###.###-##']"
                                                :disabled="!page.isNew && (!$check(user, ['lawyers.update']))">
                                            </v-text-field>
                                        </v-col>

                                        <v-col>
                                            <v-text-field dense id="procurator_email" label="E-mail"
                                                v-model="dataset.data.procurator_email" required
                                                :rules="[$rules.required]" outlined hide-details="auto"
                                                :disabled="!page.isNew && (!$check(user, ['lawyers.update']))">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input dense accept="image/png, image/jpeg, application/pdf"
                                                prepend-icon="" outlined counter required
                                                :rules="[!dataset.data.procurator_file ? $rules.required : () => true, $rules.fileSize(4)]"
                                                show-size hint="O arquivo não pode ser superior a 4MB"
                                                hide-details="auto"
                                                :label="dataset.data.is_executor ? 'Documento de identificação' : 'Documento OAB'"
                                                :clearable="true" @change="onProcuratorSelected($event)" ref="procurator_file"
                                                truncate-length="70"
                                                :disabled="!page.isNew && (!$check(user, ['lawyers.update']))">
                                            </v-file-input>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-n5" v-if="!page.isNew">
                                        <v-col class="doc-info">
                                            <span>
                                                {{ dataset.data.is_executor ? 'Documento de identificação' : 'Documento OAB atual' }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="!page.isNew">
                                        <v-col cols="3">
                                            <iframe
                                                :src="typeof dataset.data.procurator_file === 'string' ? dataset.data.procurator_file : null"
                                                width="250" height="150" frameborder="0" scrolling="no"
                                                class="rounded-xl"></iframe>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="!page.isNew">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="typeof dataset.data.procurator_file === 'string' ? dataset.data.procurator_file : null"
                                            target="_blank">
                                            Visualizar documento
                                        </v-btn>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row v-if="$check(user, ['lawyers.view.users'])">
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Credores vinculados</span>
                            </div>
                        </div>
                    </v-card-title>


                    <v-card-text>
                        <v-row v-if="!dataset.data.associatedUsers || dataset.data.associatedUsers.length === 0">
                            <v-col cols="12">
                                Nenhum credor vinculado a este procurador
                            </v-col>
                        </v-row>

                        <v-row v-else>
                            <v-col>
                                <v-expansion-panels>

                                    <v-expansion-panel v-for="(item, index) in dataset.data.associatedUsers"
                                        :key="index">

                                        <v-expansion-panel-header @click.stop>
                                            <v-row align="center">
                                                <v-col cols="6">
                                                    <strong>Nome: </strong>
                                                    <span class="ml-2 mr-2">{{ item.user.name }}</span>/
                                                    <strong>CPF/CNPJ: </strong>
                                                    <span class="ml-2 mr-2">{{
                                                        formatRegistration(item.user.registration) }}</span>
                                                </v-col>
                                                <v-col>
                                                    <strong>Criado por: </strong>{{ !item.created_by ? 'Desconhecido' :
                                                    item.created_by
                                                    == 1 ?
                                                    'Credor' : 'Procurador' }}
                                                </v-col>

                                                <v-spacer></v-spacer>

                                                <v-col>

                                                    <v-chip label class="mr-10" small
                                                        :color="getColorByStatus(item.status)"
                                                        style="color: white; min-width: 170px; justify-content: center;">
                                                        {{ getTextByStatus(item.status) }}
                                                    </v-chip>

                                                    <template v-if="item.recordType !== 'draft'">
                                                        <v-tooltip bottom>
                                                            <template #activator="{ on }">
                                                                <v-btn icon v-on="on"
                                                                    :disabled="!$check(user, ['lawyers.update.association'])"
                                                                    @click.stop="updateUserStatus(item, 1)"
                                                                    :loading="loadingUserId === item.id && loadingStatus === 1"
                                                                    size="large" color="green">
                                                                    <v-icon>mdi-check-circle</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>
                                                                Aprovar associação
                                                            </span>
                                                        </v-tooltip>

                                                        <v-tooltip bottom>
                                                            <template #activator="{ on }">
                                                                <v-btn icon v-on="on"
                                                                    :disabled="!$check(user, ['lawyers.update.association'])"
                                                                    @click.stop="updateUserStatus(item, 2)" size="large"
                                                                    :loading="loadingUserId === item.id && loadingStatus === 2"
                                                                    color="red">
                                                                    <v-icon>mdi-close-circle</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Rejeitar associação</span>
                                                        </v-tooltip>

                                                        <v-tooltip bottom>
                                                            <template #activator="{ on }">
                                                                <v-btn icon v-on="on"
                                                                    :disabled="!$check(user, ['lawyers.update.association'])"
                                                                    @click.stop="updateUserStatus(item, 3)" size="large"
                                                                    color="primary" class="me-2"
                                                                    :loading="loadingUserId === item.id && loadingStatus === 3">
                                                                    <v-icon>mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Remover associação</span>
                                                        </v-tooltip>

                                                    </template>

                                                    <v-tooltip bottom>
                                                        <template #activator="{ on }">
                                                            <v-btn icon v-on="on"
                                                                @click="viewCreditorDetails(item)" size="large"
                                                                 class="me-2 ml-5">
                                                                <v-icon>mdi-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Visualizar detalhes do credor</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>

                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content>
                                            <v-row>
                                                <v-col>
                                                    <span><strong>Nome completo</strong></span>
                                                    <br>
                                                    <span>{{ item.user.name }}</span>
                                                    <br>
                                                    <span><strong>CPF/CNPJ</strong></span>
                                                    <br>
                                                    <span>{{ formatRegistration(item.user.registration) }}</span>
                                                    <br>
                                                    <span><strong>E-mail</strong></span>
                                                    <br>
                                                    <span>{{ item.user.email }}</span>
                                                    <br>
                                                    <span><strong>Celular/Telefone</strong></span>
                                                    <br>
                                                    <span>{{ item.user.phone_number }}</span>
                                                    <br>
                                                    <span><strong>Solicitado em</strong></span>
                                                    <br>
                                                    <span>{{ item.created_at | defaultDate }}</span>
                                                    <br>
                                                    <br>

                                                    <template v-if="item.status == 2 || item.status == 3">
                                                        <span><strong>Análise</strong></span>
                                                        <br>
                                                        <span>{{ item.reason }}</span>
                                                    </template>
                                                </v-col>
                                            </v-row>

                                                                                        <v-row>
                                                                                            <v-col>
                                                                                                <v-alert
                                                                                                    v-if="item.procuration_validation_error"
                                                                                                    type="error"
                                                                                                    dense
                                                                                                    outlined
                                                                                                    class="mb-4"
	                                                                                                >
	                                                                                                    <span v-html="formatSavedProcurationValidationError(item.procuration_validation_error)"></span>
	                                                                                                </v-alert>

                                                                                                <div class="d-flex align-center">
                                                                                                    <v-tooltip bottom v-if="item.draftDocumentUrl">
                                                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                                            <a :href="item.draftDocumentUrl" target="_blank"
                                                                                                                v-bind="attrs" v-on="on"
                                                                                                                style="text-decoration: none;">
                                                                                                                <v-btn outlined color="primary"
                                                                                                                    style="height: 25px;" class="mr-2">
                                                                                                                    Procuração gerada
                                                                                                                </v-btn>
                                                                                                            </a>
                                                                                                        </template>
                                                                                                        <span>Baixar procuração gerada, ainda não assinada</span>
                                                                                                    </v-tooltip>
                                                                                                    <v-tooltip bottom v-if="item.procurationUrl">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <a :href="item.procurationUrl" target="_blank"
                                                                    v-bind="attrs" v-on="on"
                                                                    style="text-decoration: none;">
                                                                    <v-btn outlined color="primary"
                                                                        style="height: 25px;" class="mr-2"
                                                                        v-bind="attrs" v-on="on">
                                                                        Procuração
                                                                    </v-btn>
                                                                </a>
                                                            </template>
                                                            <span>Visualizar documento de procuração</span>
                                                        </v-tooltip>

                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <a :href="item.documentUrl" target="_blank"
                                                                    v-bind="attrs" v-on="on"
                                                                    style="text-decoration: none;">
                                                                    <v-btn outlined color="primary"
                                                                        style="height: 25px;" class="mr-2"
                                                                        v-bind="attrs" v-on="on">
                                                                        Identificação
                                                                    </v-btn>
                                                                </a>
                                                            </template>
                                                            <span>Visualizar documento de identificação</span>
                                                        </v-tooltip>

                                                        <v-tooltip bottom v-if="item.procuration_signature_count > 0">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on" outlined color="primary"
                                                                    style="height: 25px;" class="mr-2"
                                                                    @click="openSignatureModal(item)">
                                                                    Assinatura
                                                                </v-btn>
                                                            </template>
                                                            <span>Visualizar assinatua digital do documento de
                                                                procuração</span>
                                                        </v-tooltip>

                                                        <!-- Outros documentos -->
                                                        <v-tooltip bottom
                                                            v-if="item.otherDocuments && item.otherDocuments.length > 0">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn outlined color="primary" class="mr-2"
                                                                    style="height:25px;" v-on="on" v-bind="attrs"
                                                                    @click="openOtherDocsModal(item)">
                                                                    Outros documentos
                                                                </v-btn>
                                                            </template>
                                                            <span>Visualizar outros documentos</span>
                                                        </v-tooltip>
                                                                                                </div>
                                                                                            </v-col>
                                                                                        </v-row>

                                                                                        <v-row v-if="item.recordType !== 'draft'" class="mt-2">
                                                                                            <v-col cols="12" md="8">
                                                                                                <v-file-input
                                                                                                    dense
                                                                                                    outlined
                                                                                                    accept="application/pdf"
                                                                                                    prepend-icon="mdi-file-pdf-box"
                                                                                                    show-size
                                                                                                    hide-details="auto"
                                                                                                    label="Procuração assinada GOV.BR"
                                                                                                    :value="adminProcurationFiles[item.id]"
                                                                                                    :rules="[$rules.fileSize(10)]"
                                                                                                    :disabled="!$check(user, ['lawyers.update.association']) || uploadingProcurationId === item.id"
                                                                                                    @change="onAdminProcurationSelected(item, $event)"
                                                                                                />
                                                                                            </v-col>
                                                                                            <v-col cols="12" md="4" class="d-flex align-center">
                                                                                                <v-btn
                                                                                                    color="primary"
                                                                                                    outlined
                                                                                                    :loading="uploadingProcurationId === item.id"
                                                                                                    :disabled="!adminProcurationFiles[item.id] || !$check(user, ['lawyers.update.association'])"
                                                                                                    @click="uploadAdminProcuration(item)"
                                                                                                >
                                                                                                    Validar procuração
                                                                                                </v-btn>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </v-expansion-panel-content>

                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col cols="12"
                                v-if="!dataset.data.associatedUsers || dataset.data.associatedUsers.length === 0">
                                Nenhum credor vinculado a este procurador
                            </v-col>

                            <v-col cols="12" v-else>
                                <v-row>
                                    <v-col v-for="user in dataset.data.associatedUsers" :key="user.id" cols="12" md="12"
                                        class="mb-4">

                                        <v-row class="pa-4 elevation-2 rounded-lg" align="center"
                                            justify="space-between">

                                            <div class="d-flex flex-column">
                                                <div class="subtitle-1 mb-1">{{ user.user.name }}</div>
                                                <div class=" mb-5">{{ formatRegistration(user.user.registration) }}
                                                </div>
                                                <v-btn small color="primary" @click="viewItem(user)">
                                                    Mostrar Detalhes
                                                </v-btn>

                                            </div>

                                            <div class="d-flex align-center">
                                                <v-chip :color="getColorByStatus(user.status)"
                                                    class="mr-15 text-uppercase font-weight-bold text-caption"
                                                    text-color="white" dark small dense>
                                                    {{ getTextByStatus(user.status) }}
                                                </v-chip>

                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn fab x-small color="positive_change" dark class="ma-1"
                                                            @click="updateUserStatus(user, 1)" v-bind="attrs" v-on="on">
                                                            <template
                                                                v-if="loadingUserId === user.id && loadingStatus === 1">
                                                                <v-progress-circular indeterminate color="primary"
                                                                    size="16" width="2" />
                                                            </template>
                                                            <template v-else>
                                                                <v-icon>mdi-check</v-icon>
                                                            </template>
                                                        </v-btn>
                                                    </template>
                                                    <span>Aprovar associação</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn fab x-small :color="'red'" class="ma-1"
                                                            @click="updateUserStatus(user, 2)" v-bind="attrs" v-on="on">
                                                            <template
                                                                v-if="loadingUserId === user.id && loadingStatus === 2">
                                                                <v-progress-circular indeterminate color="primary"
                                                                    size="16" width="2" />
                                                            </template>
                                                            <template v-else>
                                                                <v-icon color="white">mdi-close</v-icon>
                                                            </template>
                                                        </v-btn>
                                                    </template>
                                                    <span>Rejeitar associação</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn fab x-small :color="'blue-grey'" class="ma-1"
                                                            @click="updateUserStatus(user, 3)" v-bind="attrs" v-on="on">
                                                            <template
                                                                v-if="loadingUserId === user.id && loadingStatus === 3">
                                                                <v-progress-circular indeterminate color="primary"
                                                                    size="16" width="2" />
                                                            </template>
                                                            <template v-else>
                                                                <v-icon color="white">mdi-delete</v-icon>
                                                            </template>
                                                        </v-btn>
                                                    </template>
                                                    <span>Remover associação</span>
                                                </v-tooltip>

                                            </div>

                                        </v-row>

                                    </v-col>
                                </v-row> -->

                        <!-- <v-row>
                                                <v-col class="ml-4">
                                                    <div class="d-flex align-center">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <a :href="user.procurationUrl" target="_blank"
                                                                    v-bind="attrs" v-on="on"
                                                                    style="text-decoration: none;">
                                                                    <v-btn outlined color="primary"
                                                                        style="height: 25px;" class="mr-2"
                                                                        v-bind="attrs" v-on="on">
                                                                        Procuração
                                                                    </v-btn>
                                                                </a>
                                                            </template>
                                                            <span>Visualizar documento de procuração</span>
                                                        </v-tooltip>

                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <a :href="user.documentUrl" target="_blank"
                                                                    v-bind="attrs" v-on="on"
                                                                    style="text-decoration: none;">
                                                                    <v-btn outlined color="primary"
                                                                        style="height: 25px;" class="mr-2"
                                                                        v-bind="attrs" v-on="on">
                                                                        Identificação
                                                                    </v-btn>
                                                                </a>
                                                            </template>
                                                            <span>Visualizar documento de identificação</span>
                                                        </v-tooltip>
                                                    </div>
                                                </v-col>
                                            </v-row> -->

                        <!-- </v-col>

                        </v-row> -->
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Modal Motivo Remocao/Rejeicao -->
        <v-dialog v-model="showRejectConfirmation" max-width="600px">
            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    MOTIVO
                </v-card-title>
                <br>
                <v-card-text>
                    <p>
                        Digite o motivo pelo qual deseja <strong>
                            {{ rejectionStatus === 2 ? 'rejeitar' : rejectionStatus === 3 ? 'remover' : 'alterar' }}
                        </strong>
                        a associação.
                    </p>
                    <br>
                    <v-form ref="rejectionForm" @submit.prevent="confirmRejectStatus">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-textarea label="Motivo" v-model="rejectionReasonText" outlined dense clearable
                                    auto-grow rows="1" counter maxlength="255"></v-textarea>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn text color="grey" @click="cancelReject">Cancelar</v-btn>
                            <v-btn color="primary" type="submit" :loading="loadingUserId">Salvar</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal Assinaturas Digitais da Procuração -->
        <v-dialog v-model="signaturesModal" max-width="800px">
            <v-card>
                <v-card-title class="headline font-weight-bold">
                    <v-icon left color="primary">mdi-file-sign</v-icon>
                    Assinatura Digital
                </v-card-title>

                <v-divider />
                <template v-if="dataset.procurationSignatures">
                    <v-card-text>
                        <v-list two-line>
                            <v-list-item v-for="(assinatura, index) in JSON.parse(dataset.procurationSignatures)"
                                :key="index" class="pa-3">

                                <v-list-item-content class="d-block">
                                    <v-list-item-title class="font-weight-bold">
                                        {{ assinatura.signerName }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text--secondary">
                                        {{ assinatura.signerEmail || 'E-mail não informado' }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="text--secondary">
                                        {{ formatRegistration(assinatura.signerRegistration) || 'CPF não informado' }}
                                    </v-list-item-subtitle>
                                    <br>
                                    <v-list-item-title class="font-weight-bold">
                                        {{ assinatura.organizationName }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text--secondary">
                                        {{ assinatura.organizationalUnitName }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="text--secondary">
                                        {{ assinatura.issuer }}
                                    </v-list-item-subtitle>

                                    <v-row class="mt-0">
                                        <v-col cols="3">
                                            <v-chip color="green" text-color="white" small>
                                                Válido de: {{ formatDate(assinatura.certificateValidFrom) }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-chip color="warning" text-color="white" small>
                                                Válido até: {{ formatDate(assinatura.certificateValidTo) }}
                                            </v-chip>
                                        </v-col>
                                    </v-row>

                                    <v-divider />

                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <div
                            v-if="!dataset.procurationSignatures || JSON.parse(dataset.procurationSignatures).length === 0">
                            <v-alert type="info" border="left" colored-border>
                                Nenhum dado de assinatura foi encontrado para esta procuração.
                            </v-alert>
                        </div>
                    </v-card-text>
                </template>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" text @click="signaturesModal = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal Outros Documentos -->
        <v-dialog v-model="modal.otherDocs" max-width="800px">
            <v-card>
                <v-card-title class="headline">
                    Outros Documentos
                </v-card-title>

                <v-card-text>
                    <div v-if="selected.otherDocs && selected.otherDocs.length">
                        <v-list two-line>
                            <v-list-item v-for="doc in selected.otherDocs" :key="doc.name">
                                <v-list-item-content>
                                    <v-list-item-title>{{ doc.name }}</v-list-item-title>

                                    <a :href="doc.url" target="_blank">
                                        <v-btn small color="primary" class="mt-2">
                                            Visualisar
                                        </v-btn>
                                    </a>

                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal.otherDocs = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import sanitizers from '@/common/util/string'
import statesList from "@/common/data/states-list.data";
import axios from "axios"

export default {
    name: "LawyerDetails",

    data: () => ({
        modal: {
            otherDocs: false
        },
        selected: {
            otherDocs: []
        },
        statesList: statesList,
                                                    userLawyerData: null,
                                                    loadingUserId: null,
                                                    loadingStatus: null,
                                                    uploadingProcurationId: null,
                                                    adminProcurationFiles: {},
                                                    showRejectConfirmation: false,
        signaturesModal: false,
        userToRejectId: null,
        rejectionReasonText: '',
        rejectionResolve: null,
        rejectionUser: null,
        rejectionStatus: null,
        loadingRejectionReason: false,
        page: {
            isNew: false,
            title: "",
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        user: null,
        otherAssociations: null,
        data: [],
        validForm: false,
        loading: false,
        dialog: false,
        selectedItem: null,
        dataset: {
            contentUserAnonymous: '',
            contentUserLogged: '',
            isAssociationCreditor: false,
            userRequestedValue: 0,
            loading: false,
            clients: [],
            data: {
                procurator_name: '',
                procurator_email: '',
                procurator_federal_registration: '',
                procurator_federal_registration_uf: '',
                procurator_file: '',
                procurator_registration: '',
                associatedUsers: [],
                account_verified_at: '',
                is_executor: null,
            },
            statesList: statesList,
            procurationSignatures: null,
        },
        selectedDoc: null,
        processes: [],
        loadingProcurator: false,
        showAddProcuratorForm: false,
        newProcurator: {
            name: '',
            email: '',
            federal_registration: '',
            federal_registration_uf: '',
        },
        selectedProcuratorFile: null,
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData()
    },

    computed: {
        fileRules() {
            const rules = [];
            if (!this.dataset.data.procurator_file) {
                rules.push(this.$rules.required);
            }
            rules.push(this.$rules.fileSize(150));
            return rules;
        },
    },

    methods: {

        formatCpf(value) {
            if (!value) return '';
            return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
        },

        formatCnpj(value) {
            if (!value) return '';
            return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
        },

        formatRegistration(value) {
            if (!value) return '';
            return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
        },

        openOtherDocsModal(item) {
            this.selected.otherDocs = item.otherDocuments || [];
            this.modal.otherDocs = true;
        },

        goBack() {
            this.$router.replace("/procuradores");
        },

        async loadData() {
            await this.load();
            await this.loadAssociatedUsers();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo procurador' : 'Detalhes do procurador'}`;
        },

        viewItem(user) {
            window.location.href = `#/credores/${user.user.id}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
                {
                    text: "Procuradores",
                    disabled: false,
                    to: "/procuradores",
                    exact: true,
                },
                {
                    text: `${this.page.isNew ? 'Novo procurador' : 'Detalhes do procurador'}`,
                    disabled: true,
                    exact: true,
                }
            ];
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja adicionar o procurador?',
                title: 'Incluir procurador',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const formData = new FormData();

                formData.append("name", this.dataset.data.procurator_name || '');
                formData.append("email", this.dataset.data.procurator_email || '');
                formData.append("federal_registration", this.dataset.data.procurator_federal_registration || '');
                formData.append("federal_registration_uf", this.dataset.data.procurator_federal_registration_uf || '');
                formData.append("registration", this.dataset.data.procurator_registration.replace(/\D/g, '') || '');

                if (this.selectedProcuratorFile) {
                    formData.append("files", this.selectedProcuratorFile);
                }

                const result = await axios.post("/api/admin/lawyers/create", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });

                this.$dialog.notify.info("Procurador salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do procurador?',
                title: 'Atualizar credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            });

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const formData = new FormData();

                formData.append("name", this.dataset.data.procurator_name || '');
                formData.append("email", this.dataset.data.procurator_email || '');
                formData.append("federal_registration", this.dataset.data.procurator_federal_registration || '');
                formData.append("federal_registration_uf", this.dataset.data.procurator_federal_registration_uf || '');
                formData.append("registration", this.dataset.data.procurator_registration.replace(/\D/g, '') || '');

                if (this.selectedProcuratorFile) {
                    formData.append("files", this.selectedProcuratorFile);
                }

                const response = await axios.patch(
                    `/api/admin/lawyers/update/${this.$route.params.id}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`
                        }
                    }
                );

                if (response.data.content.documentUrl) {
                    this.dataset.data.procurator_file = response.data.content.documentUrl;
                }

                this.$dialog.notify.info("Procurador atualizado com sucesso!", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            if (this.page.isNew) return;

            const token = localStorage.getItem("token");
            if (!token) return;

            try {
                const result = await axios.get(`/api/admin/lawyers/find/${this.$route.params.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const lawyer = result.data.content;

                this.dataset.data.procurator_name = lawyer.name || '';
                this.dataset.data.procurator_email = lawyer.email || '';
                this.dataset.data.procurator_federal_registration = lawyer.federal_registration || '';
                this.dataset.data.procurator_federal_registration_uf = lawyer.federal_registration_uf || '';
                this.dataset.data.procurator_file = lawyer.documentUrl || '';
                this.dataset.data.account_verified_at = lawyer.account_verified_at;
                this.dataset.data.procurator_registration = this.formatCpf(lawyer.registration) || '';
                this.dataset.data.is_executor = lawyer.is_executor

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadAssociatedUsers() {
            try {
                const result = await axios.get(`/api/admin/lawyers/associated-users/${this.$route.params.id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });


                //this.dataset.data.associatedUsers = result.data.content || [];

                this.dataset.data.associatedUsers = (result.data.content.associations || []).map(user => {
                    return {
                        ...user,
                        status: typeof user.status === 'undefined' ? 0 : user.status
                    }
                });

                if (result.data.content && result.data.content.otherAssociations) {
                    this.otherAssociations = result.data.content.otherAssociations
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.procurator_name || '',
                email: this.dataset.data.procurator_email || '',
                federal_registration: this.dataset.data.procurator_federal_registration || '',
                federal_registration_uf: this.dataset.data.procurator_federal_registration_uf || '',
                procurator_file: this.dataset.data.procurator_file || '',
                registration: this.dataset.data.procurator_registration.replace(/\D/g, '') || '',
            };
            return data;
        },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },

        onProcurationSelected(file) {
            this.dataset.data.procuration_file = file;
        },

        onProcuratorSelected(file) {
            this.selectedProcuratorFile = file;
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'positive_change'
                case 2:
                    return 'important'
                case 3:
                    return 'blue-grey'
                case 4:
                    return "deep-orange";
                case 5:
                    return "error";
                default:
                    break
            }
        },

        getTextByStatus(status) {
            switch (status) {
                case 0:
                    return 'Pendente'
                case 1:
                    return 'Aprovado'
                case 2:
                    return 'Rejeitado'
                case 3:
                    return 'Removido'
                case 4:
                    return "Aguardando procuração";
                case 5:
                    return "Atualização procurador";
                default:
                    break
            }
        },

        async updateUserStatus(user, status) {
            if (Number(user.status) === Number(status)) {
                const message = {
                    1: "A associação já está aprovada!",
                    2: "A associação já está rejeitada!",
                    3: "A associação já está removida!",
                }[status] || "O status atual já corresponde ao solicitado.";

                this.$dialog.notify.warning(message, {
                    position: "top-right",
                    timeout: 2000
                });
                return;
            }

            if ([2, 3].includes(Number(status))) {
                this.rejectionUser = user;
                this.rejectionStatus = status;
                this.rejectionReasonText = '';
                this.showRejectConfirmation = true;
                return;
            }

            await this.sendStatusUpdate(user, status);
        },

        cancelReject() {
            this.showRejectConfirmation = false;
            this.rejectionReasonText = '';
            this.rejectionUser = null;
            this.rejectionStatus = null;
        },

        async confirmRejectStatus() {

            if (!this.rejectionReasonText.trim()) {
                this.$dialog.notify.warning('Digite um motivo para prosseguir.', {
                    position: 'top-right'
                });
                return;
            }

            const user = this.rejectionUser;
            const status = this.rejectionStatus;

            this.showRejectConfirmation = false;

            await this.sendStatusUpdate(user, status, this.rejectionReasonText);

            this.rejectionUser = null;
            this.rejectionStatus = null;
            this.rejectionReasonText = '';
        },

        async sendStatusUpdate(user, status, reason = null) {
            this.loadingUserId = user.id;
            this.loadingStatus = status;

            const payload = { status };
            if (reason) payload.reason = reason;

            try {
                await axios.patch(`/api/admin/lawyers/association-user-action/${user.id}`, payload);

                this.$dialog.notify.info("Associação atualizada com sucesso!", {
                    position: "top-right",
                    timeout: 5000
                });

                this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 5000
                });
            } finally {
                this.loadingUserId = null;
                this.loadingStatus = null;
            }
        },

        async verifyAccount() {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja verificar a conta?',
                title: 'Verificar conta',
                actions: {
                    false: 'Cancelar',
                    true: 'Verificar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                const response = await axios.post(`/api/admin/lawyers/verify-account/${this.$route.params.id}`, {});

                this.$dialog.notify.info("Conta verificada com sucesso!", { position: "top-right", timeout: 2000 });

                this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

                                                    openSignatureModal(item) {
                                                        this.dataset.procurationSignatures = item.procuration_signatures;
                                                        this.signaturesModal = true;
                                                    },

                                                    onAdminProcurationSelected(item, file) {
                                                        this.$set(this.adminProcurationFiles, item.id, file);
                                                    },

                                                    async uploadAdminProcuration(item) {
                                                        const file = this.adminProcurationFiles[item.id];

                                                        if (!file) {
                                                            this.$dialog.notify.warning('Selecione a procuração assinada antes de validar.', {
                                                                position: 'top-right',
                                                                timeout: 3000
                                                            });
                                                            return;
                                                        }

                                                        const formData = new FormData();
                                                        formData.append('signed_pdf', file);

                                                        this.uploadingProcurationId = item.id;

                                                        try {
                                                            await axios.post(`/api/admin/lawyers/association-user-upload-template-pdf/${item.id}`, formData, {
                                                                headers: {
                                                                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                                                                },
                                                            });

                                                            this.$dialog.notify.info('Procuração validada com sucesso!', {
                                                                position: 'top-right',
                                                                timeout: 5000
                                                            });

                                                            this.$delete(this.adminProcurationFiles, item.id);
                                                            await this.loadAssociatedUsers();
                                                        } catch (error) {
                                                            this.$dialog.confirm({
                                                                html: true,
                                                                text: this.formatProcurationUploadError(this.$codes(error)),
                                                                title: 'Erro na validação da procuração',
                                                                actions: {
                                                                    true: 'OK'
                                                                }
                                                            });

                                                            await this.loadAssociatedUsers();
                                                        } finally {
                                                            this.uploadingProcurationId = null;
                                                        }
                                                    },

	                                                    formatProcurationUploadError(message) {
	                                                        const safeMessage = this.normalizeProcurationValidationMessage(message);
	                                                        return `
	                                                            <strong>Não foi possível validar a procuração enviada.</strong><br><br>
	                                                            ${safeMessage}
	                                                        `;
	                                                    },

	                                                    formatSavedProcurationValidationError(message) {
	                                                        return `
	                                                            <strong>Último erro na validação da procuração:</strong><br>
	                                                            ${this.normalizeProcurationValidationMessage(message)}
	                                                        `;
	                                                    },

	                                                    normalizeProcurationValidationMessage(message) {
	                                                        const safeMessage = message || 'Erro desconhecido ao validar o PDF da procuração.';
	                                                        const lowerMessage = safeMessage.toLowerCase();

	                                                        if (lowerMessage.includes('referência não encontrada')) {
	                                                            return 'Não localizamos no PDF o código interno da procuração gerada pela plataforma. Isso geralmente acontece quando o arquivo enviado não é a procuração baixada no sistema, foi escaneado/impresso, ou foi salvo novamente por outro editor antes da assinatura. Baixe novamente a procuração na plataforma, assine o PDF original pelo GOV.BR sem alterar o arquivo e envie exatamente o PDF assinado.';
	                                                        }

	                                                        if (lowerMessage.includes('informações do documento de procuração não encontradas')) {
	                                                            return 'Não localizamos no PDF as informações internas de segurança da procuração gerada pela plataforma. O arquivo pode ter sido editado, convertido, impresso/escaneado ou pode não ser o documento gerado pelo sistema. Baixe novamente a procuração na plataforma, assine o PDF original pelo GOV.BR sem alterar o arquivo e envie exatamente o PDF assinado.';
	                                                        }

	                                                        if (lowerMessage.includes('documento de procuração não confere')) {
	                                                            return 'O PDF enviado possui dados internos diferentes da procuração gerada pela plataforma. Isso indica que o arquivo não corresponde ao documento original ou foi alterado após a geração. Baixe novamente a procuração, assine o PDF original pelo GOV.BR e envie o arquivo assinado sem editar, renomear por conversores, compactar, imprimir ou escanear.';
	                                                        }

	                                                        if (lowerMessage.includes('assinatura digital não localizada')) {
	                                                            return 'Não encontramos assinatura digital no PDF enviado. O arquivo precisa ser o PDF assinado digitalmente pelo GOV.BR, não apenas a procuração baixada, uma imagem, uma digitalização ou o comprovante/resumo da assinatura.';
	                                                        }

	                                                        if (lowerMessage.includes('assinatura não aceita')) {
	                                                            return 'A assinatura digital encontrada não foi emitida pela plataforma GOV.BR. Para esta validação, o documento deve ser assinado exclusivamente pelo GOV.BR. Assine novamente a procuração original usando GOV.BR e envie o PDF assinado gerado ao final do processo.';
	                                                        }

	                                                        if (lowerMessage.includes('nenhum representante legal')) {
	                                                            return 'Este credor é uma empresa, mas não há representante legal cadastrado/aprovado para validar a assinatura. Cadastre ou regularize o representante legal da empresa e depois envie novamente a procuração assinada por esse representante.';
	                                                        }

	                                                        if (lowerMessage.includes('representante cadastrado') || lowerMessage.includes('representante legal aprovado')) {
	                                                            return 'O CPF do assinante digital não corresponde a nenhum representante legal cadastrado/aprovado para esta empresa. O PDF deve ser assinado pelo representante legal vinculado ao cadastro do credor. Verifique o representante cadastrado ou assine novamente com o CPF correto pelo GOV.BR.';
	                                                        }

	                                                        if (lowerMessage.includes('cpf do assinante')) {
	                                                            return 'O CPF do assinante digital não corresponde ao CPF do credor selecionado. Confirme se a procuração pertence a este credor e se foi assinada no GOV.BR pelo próprio credor correto. Se necessário, gere uma nova procuração para o credor correto e assine novamente.';
	                                                        }

	                                                        return safeMessage;
	                                                    },

	                                                    formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('pt-BR');
        },

        viewCreditorDetails(user) {
            this.$router.push({ path: `/credores/${user.user.id}` });
        },

    }
};
</script>


<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.doc-info {
    color: var(--v-primary-base);
    font-size: 16px;
    font-style: normal;
}
</style>
